import React from 'react'

function Ksiazki() {
  return (
    <div>Ksiazki</div>
  )
}

export default Ksiazki